export default __webpack_public_path__ + "media/src/features/footer/assets/twitter@2x-f68eb759e8aca9041ecdf7bfb4b94267.png";